import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import apiInstance from '../../../services/ServiceApi';

function CuotasAplazaloOH({ cuenta_cliente, id_linea_negocio, onChange, etiqueta,valoresIniciales = {}, user_bo = true }) {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await apiInstance.get(`cuentaDetalle/?cuenta_id=${cuenta_cliente.id}&id_linea_negocio=${id_linea_negocio}&user_bo=${user_bo}`);
            setData(response.data);
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
        };

        fetchData();
    }, [cuenta_cliente, id_linea_negocio]);

    useEffect(() => {
        if (valoresIniciales && data.length > 0) {
            const rowToSelect = data.find(
                (row) =>
                row.id === valoresIniciales.id  
            );
            if (rowToSelect) {
                console.log("hat coincidencia")
                setSelectedRow(rowToSelect);
            }
        }
    }, [valoresIniciales, data]);

    const handleRowClick = (row) => {
        setSelectedRow(row);
        onChange(row);
    };

    return (
        <>
        <Typography variant="h6" gutterBottom>
            {etiqueta}
        </Typography>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="Cuotas">
            <TableHead>
                <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Llave</TableCell>
                <TableCell>Código Externo</TableCell>
                <TableCell>Deuda Reprogramable</TableCell>
                <TableCell>Monto Cuota</TableCell>
                <TableCell>Número de Cuota</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((row) => (
                <TableRow
                    key={row.id}
                    onClick={() => handleRowClick(row)}
                    style={{
                    backgroundColor: selectedRow === row ? '#48c848' : 'inherit', // Cambia el color de fondo si la fila está seleccionada
                    cursor: 'pointer', // Cambia el cursor al pasar sobre la fila
                    }}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.llave}</TableCell>
                    <TableCell>{row.codigo_externo}</TableCell>
                    <TableCell>{row.deuda_reprogramable}</TableCell>
                    <TableCell>{row.monto_cuota}</TableCell>
                    <TableCell>{row.numero_cuota}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        </>
    );
}

export default CuotasAplazaloOH;
